import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AppContextProvider } from "../context/GlobalStore";

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <BrowserRouter>
      <AppContextProvider>{children}</AppContextProvider>
    </BrowserRouter>
  );
};

export default Providers;
